import React from 'react';
import { Bot } from 'lucide-react';
import MediaDisplay from './MediaDisplay';

const GogiAISystem = ({ imageUrl }) => {
  return (
    <div className="w-full max-w-5xl mx-auto">
      <div className="relative overflow-hidden rounded-2xl">
        {imageUrl ? (
          <MediaDisplay
            src={imageUrl}
            fallbackSrc="/website-al-logo.png"
            alt="Gogi AI"
            className="w-full h-auto object-cover aspect-video"
            imgProps={{ loading: 'lazy' }}
          />
        ) : (
          <div className="aspect-video bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-600 flex items-center justify-center">
            <div className="flex flex-col items-center justify-center text-white">
              <div className="w-20 h-20 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center mb-4">
                <Bot className="w-10 h-10" />
              </div>
              <div className="text-center">
                <p className="text-2xl font-bold">Gogi AI</p>
                <p className="text-sm text-white/90">Yapay zeka deneyimini keşfetmek için tıklayın</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GogiAISystem;